import { createSlice } from "@reduxjs/toolkit";

const aiChatSlice = createSlice({
    name: "aiChat",
    initialState: {
        threads : ""
    },
    reducers:{
        setThreads : (state, action) => {
            state.threads = action.payload;
        },
        updateThread : (state, action) => {
            const { thread_id, updatedThread } = action.payload;
            const threadIndex = state.threads.findIndex(thread => thread?.thread_id === thread_id);
            if (threadIndex !== -1) {
                state.threads[threadIndex] = { ...state.threads[threadIndex], ...updatedThread };
            } else {
                state.threads.push(updatedThread);
            }
        },
    }
})

export const {
    setThreads,
    updateThread,
} = aiChatSlice.actions;

export default aiChatSlice.reducer;